import * as types from '../constants/ActionTypes';

const initialState = {
  ppcEnable: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_PPC_ENABLE: {
      return { ...state, isLoading: true, error: false };
    }
    case types.RECEIVE_PPC_ENABLE: {
      return {
        ...state,
        isLoading: false,
        error: false,
        ppcEnable: action.payload,
      };
    }
    case types.RECEIVE_PPC_ENABLE_ERROR: {
      return { ...state, isLoading: false, error: true };
    }
    default:
      return state;
  }
}
